import { render } from "./AvatarParticipationStatus.vue?vue&type=template&id=2b2b7b43&scoped=true"
import script from "./AvatarParticipationStatus.vue?vue&type=script&lang=js"
export * from "./AvatarParticipationStatus.vue?vue&type=script&lang=js"

import "./AvatarParticipationStatus.vue?vue&type=style&index=0&id=2b2b7b43&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2b7b43"]])

export default __exports__